
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-facility-info-dialog',
  standalone: true,
  imports: [],
  templateUrl: './facility-info-dialog.component.html',
  styleUrl: './facility-info-dialog.component.css'
})
export class FacilityInfoDialogComponent {

  @Input() item: any;
  activeTab: string = 'info'; // default tab

  constructor(public activeModal: NgbActiveModal) {
   }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  isActive(tab: string): boolean {
    return this.activeTab === tab;
  }

  close() {
    this.activeModal.close();
  }

}
